document.addEventListener('DOMContentLoaded', () => {

  const sliders = document.querySelectorAll('.heroSwiper');

  sliders.forEach((slider) => {

    new Swiper(slider, {
      loop: true,

      centeredSlides: true,

      slidesPerView: 'auto',

      spaceBetween: 20,

      speed: 800,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        0: {
          spaceBetween: 10,
        },

        768: {
          spaceBetween: 16,
        },

        1200: {
          spaceBetween: 20,
        }
      }
    });

  });

});